module.exports = __webpack_public_path__ + "img/CAST服务认证证书.aeb67c8a.jpg";